import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum GiftVoucherStayPackageValidityModeId {
  OPEN_DATES = 'open_dates',
  SPECIFIC_DATES = 'specific_dates',
}

export class GiftVoucherStayPackageValidityMode extends Codebook<GiftVoucherStayPackageValidityModeId> {
  static readonly OPEN_DATES = new GiftVoucherStayPackageValidityMode(
    GiftVoucherStayPackageValidityModeId.OPEN_DATES,
    () => $t('Open dates'),
  )
  static readonly SPECIFIC_DATES = new GiftVoucherStayPackageValidityMode(
    GiftVoucherStayPackageValidityModeId.SPECIFIC_DATES,
    () => $t('Specific dates'),
  )

  private constructor(
    id: GiftVoucherStayPackageValidityModeId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
